module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-panel', {
    attrs: {
      "contextual-style": "primary"
    }
  }, [_c('h1', {
    staticClass: "panel-title",
    slot: "heading"
  }, [_vm._v("\n      Password Reset\n    ")]), _vm._v(" "), (_vm.status == 'checking') ? _c('div', {
    slot: "body"
  }, [_c('p', [_vm._v("\n        Please wait while we check the password reset token..."), _c('br'), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.status == 'check-fail') ? _c('div', {
    slot: "body"
  }, [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n        ERROR: " + _vm._s(_vm.errmsg)), _c('br'), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), (_vm.status == 'done') ? _c('div', {
    slot: "body"
  }, [_c('p', {
    staticStyle: {
      "ccolor": "red"
    }
  }, [_vm._v("\n        Thank you - Your password has been changed."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n        You can now "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login.index'
      }
    }
  }, [_vm._v("click here")]), _vm._v(" to login.\n      ")], 1)]) : _vm._e(), _vm._v(" "), (_vm.status == 'check-ok') ? _c('div', {
    slot: "body"
  }, [_c('p', {
    attrs: {
      "align": "center"
    }
  }), _c('h4', [_vm._v("Please enter your new password:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("NB:")]), _vm._v(" Your password must be at least 8 characters long, and contain at least 1 uppercase letter, 1 lowercase letter, 1 number and 1 special charactor "), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.resetpw()
      }
    }
  }, [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": "",
      "type": "button",
      "aria-label": "Help"
    }
  }, [_c('i', {
    staticClass: "fa fa-key fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password1),
      expression: "password1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "autofocus": "",
      "placeholder": "New password",
      "aria-label": "New password"
    },
    domProps: {
      "value": (_vm.password1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password1 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": "",
      "type": "button",
      "aria-label": "Help"
    }
  }, [_c('i', {
    staticClass: "fa fa-key fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password2),
      expression: "password2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Confirm new password",
      "aria-label": "Confirm new password"
    },
    domProps: {
      "value": (_vm.password2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticClass: "input-group-btn",
    attrs: {
      "align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": _vm.doingSomething,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.resetpw()
      }
    }
  }, [_vm._v("Confirm")])])])]), _vm._v(" "), (_vm.errmsg !== '') ? _c('p', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('br'), _vm._v("ERROR: " + _vm._s(_vm.errmsg) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('p')]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79c640e2"}!./src/app/pages/user/pwresetlink/index.html
// module id = 233
// module chunks = 1